import { z } from "zod"

import { isGID } from "~/lib/shopify/utils/id"

export const gidSchema = z
  .string()
  .refine(isGID, `Invalid GID. It should be in the form of "gid://shopify/GlobalIDNames/ID"`)
